import { z } from 'zod';
/**
 * Защитные лимиты воркспейса.
 * Именно отсутствие этих лимитов в старой системе дало пятикратный перерасход
 * бюджета за три дня — поэтому они появляются в модели с первого шага.
 */
export const workspaceLimitsSchema = z.object({
    /** Максимум сообщений агента в одном диалоге. */
    maxMessagesPerConversation: z.number().int().positive().default(40),
    /** Максимальная стоимость одного диалога в USD. При достижении агент останавливается. */
    maxConversationCostUsd: z.number().positive().default(1.5),
    /** Максимум итераций петли инструментов за один проход. */
    maxToolIterations: z.number().int().min(1).max(30).default(10),
    /** Порог прохода Validation Gate, шкала 0-10. */
    validationMinScore: z.number().int().min(0).max(10).default(7),
    /** Сколько раз разрешено перегенерировать ответ после отклонения. */
    validationMaxAttempts: z.number().int().min(0).max(3).default(1),
});
export const DEFAULT_WORKSPACE_LIMITS = workspaceLimitsSchema.parse({});
export const workspaceSchema = z.object({
    id: z.uuid(),
    name: z.string().min(1).max(200),
    slug: z
        .string()
        .min(2)
        .max(64)
        .regex(/^[a-z0-9-]+$/, 'Только строчные латинские буквы, цифры и дефис'),
    timezone: z.string().min(1).max(64),
    defaultCurrency: z.string().length(3),
    limits: workspaceLimitsSchema,
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const createWorkspaceSchema = workspaceSchema
    .pick({ name: true, slug: true })
    .extend({
    timezone: z.string().min(1).max(64).default('UTC'),
    defaultCurrency: z.string().length(3).default('USD'),
    limits: workspaceLimitsSchema.optional(),
});
//# sourceMappingURL=workspace.js.map